<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('advices.tvsiylr')" />
      <h3>{{ $t('advices.tvsiylr') }}</h3>

      <div class="row mt-3">
        <div class="col-lg-8">
          <p class="lead">
            {{ $t('advices.buBlmdSizAktivProfilinizlBalDahaEffektivIlmkNLazmT') }}
          </p>

          <div
            v-if="advices.length<1"
            class="alert alert-info"
          >
            {{ $t('advices.aktivProfilinizlBalTvsiyQeydAlnmamdr') }}
          </div>

          <div class="list-group">
            <div
              v-for="a in advices"
              :key="a.id"
              class="list-group-item list-group-item-action"
              style="cursor: pointer"
              @click="showAdvice(a.id)"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>{{ a.title }}</div>
                <feather
                  type="chevron-right"
                  class="text-primary"
                  size="20"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{ $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {name: company.name, getCompanyFormat: getCompanyFormat(company.format)}) }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }} <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getAdvice, getAdvices, getFeedbacks, getInvoices,} from "@/repositories/GeneralDataRepository";
import {mediaBase, paymentDomain} from "@/repositories/Repository";
import {
  buildLongId,
  getCompanyFormat,
  getPhoto,
  getProfileName
} from "@/repositories/Utils";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      paymentDomain: paymentDomain,
      advices: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {

    this.getList();

  },
  methods: {

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getList() {
      getAdvices(this.token).then(data => {
        this.advices = data;

      })
    },
    showAdvice(id) {

      getAdvice(id, this.token).then((advice) => {

        if (advice) {
          this.$swal({
            title: `${advice.title}`,
            html: `${advice.description}`,
            icon: 'info',
            confirmButtonText: 'Tamam',
          })
        }

      });
    }
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
